import * as React from 'react';

import { cn } from 'utils/shadcn';

import Opendock from '../assets/opendock-logo.png';

export default function OpendockLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  const { className: classNameProp, ...otherProps } = props;

  return (
    <img
      src={Opendock}
      alt='Opendock logo'
      className={cn('filter brightness-90 scale-125', classNameProp)}
      {...otherProps}
    />
  );
}
